import * as React from 'react';
import NavigateRightUpOutlined from './navigate-right-up-outlined';
import NavigateRightUpFilled from './navigate-right-up-filled';
import type { IconCombinedProps } from './types';
const NavigateRightUpCombined = React.forwardRef<SVGSVGElement, IconCombinedProps>((props, ref) => {
  const {
    isFocused,
    isHovered,
    isPressed,
    ...rest
  } = props;
  if (isFocused || isHovered || isPressed) {
    return <NavigateRightUpFilled ref={ref} {...rest} />;
  }
  return <NavigateRightUpOutlined ref={ref} {...rest} />;
});
export default NavigateRightUpCombined;